import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plug, RefreshCw } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";

export default function IntegrationsPanel() {
  const [connectors, setConnectors] = useState([]);
  const [summary, setSummary] = useState(null);

  const load = () => api.get("/integrations/connectors").then(({ data }) => {
    setConnectors(data.connectors); setSummary(data.summary);
  });
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="integrations-panel">
      <div className="toolbar">
        <div className="section-label" style={{ margin: 0 }}>
          <Plug size={14} style={{ verticalAlign: "-2px", marginRight: 6 }} /> Executive Integration Status
        </div>
        <div className="spacer" />
        {summary && <span style={{ fontSize: 12, opacity: 0.7 }}>{summary.live} live · {summary.awaiting} awaiting · {summary.issue} issue</span>}
        <button className="btn-ghost" onClick={load}><RefreshCw size={13} /> Refresh</button>
      </div>

      <div style={{ display: "grid", gap: 10 }}>
        {connectors.map((c) => (
          <div key={c.panel} className="card" data-testid={`connector-${c.panel}`}
               style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 220 }}>
              <div style={{ fontWeight: 600 }}>{c.label}</div>
              <div style={{ fontSize: 12, opacity: 0.7 }}>{c.connector} · {c.version}</div>
              <div style={{ fontSize: 11, opacity: 0.6, marginTop: 2 }}>{c.message}</div>
            </div>
            <StatusBadge status={c.status} lastSync={c.last_sync} />
          </div>
        ))}
      </div>
    </div>
  );
}
